
interface StickyNoteSizeControlsProps {
  visible: boolean
  disabled?: boolean
  onNudge: (dx: number, dy: number) => void
}

export default function StickyNoteSizeControls({ visible, disabled, onNudge }: StickyNoteSizeControlsProps) {
  if (!visible || disabled) return null
  return (
    <div className="absolute right-1 top-1 flex gap-1 bg-black/10 rounded p-1 backdrop-blur-sm">
      <button className="px-1.5 py-0.5 text-[10px] rounded hover:bg-black/20" title="Wider" onClick={(e) => { e.stopPropagation(); onNudge(20, 0) }}>↔+</button>
      <button className="px-1.5 py-0.5 text-[10px] rounded hover:bg-black/20" title="Narrower" onClick={(e) => { e.stopPropagation(); onNudge(-20, 0) }}>↔−</button>
      <button className="px-1.5 py-0.5 text-[10px] rounded hover:bg-black/20" title="Taller" onClick={(e) => { e.stopPropagation(); onNudge(0, 20) }}>↕+</button>
      <button className="px-1.5 py-0.5 text-[10px] rounded hover:bg-black/20" title="Shorter" onClick={(e) => { e.stopPropagation(); onNudge(0, -20) }}>↕−</button>
    </div>
  )
}
